// src/utils/openFaxRequest.js
// A pop-up asked to open a fax (3.24.0): the app switches to Outbox / Inbox
// and the list opens that fax's panel once the fax is in the loaded list.
// One request at a time; it's dropped after a minute if never used.
let pending = null;

export function requestOpenFax(tab, faxId) {
  pending = faxId ? { tab, faxId, at: Date.now() } : null;
}

// The fax to open for this tab, if any (and clears the request)
export function takeOpenFax(tab, ids) {
  if (!pending || pending.tab !== tab) return null;
  if (Date.now() - pending.at > 60 * 1000) { pending = null; return null; }
  if (!ids.includes(pending.faxId)) return null;
  const id = pending.faxId;
  pending = null;
  return id;
}
